import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "../App.css";
import Header from "./header";
import SideNav from "./sidenav";
import Back from "../assets/images/arrow2.png";
import Product1 from "../assets/images/product-1.jpg";
import Product2 from "../assets/images/product-2.jpg";
import Product3 from "../assets/images/product-3.jpg";
import Product4 from "../assets/images/product-4.jpg";
import Veg from "../assets/images/veg.png";
import NonVeg from "../assets/images/non-veg.png";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { orderDetailsAction } from "../redux/actions/productAction";
import { update } from "lodash";
import { orderStatusAction } from "../redux/actions/orderAction";
import { toast } from "react-toastify";

const initialState = {
  OrderDatas: [],
  status: "",
};

const StoreOrderDetails = () => {
  const [iState, updateState] = useState(initialState);
  const { storeDetilsData, OrderDatas, status } = iState;
  const dispatch = useDispatch();
  const { state } = useLocation();
  const { orderDetailsData } = useSelector((state) => state.product);
  const storeId = JSON.parse(localStorage.getItem("orderId"));

  //   const storeid = JSON.parse(localStorage.getItem("ownerLogin"))?._id;
  useEffect(() => {
    updateState({ ...iState, OrderDatas: orderDetailsData?.data });
    localStorage.setItem("orderId", JSON.stringify(state));
  }, [orderDetailsData]);

  useEffect(() => {
    dispatch(orderDetailsAction({ orderId: state || storeId }));
  }, [state]);

  const handleChange = (e) => {
    const { name, value } = e?.target;
    updateState({ ...iState, [name]: value });
  };

  const changeOrderStatus = (id, status) => {
    dispatch(orderStatusAction({ orderId: OrderDatas?._id, status }))
      .then((res) => {
        // console.log(res)
        if (status === "Preparing" || "Completed") {
          dispatch(orderDetailsAction({ orderId: state || storeId }));
        }
      })
      .catch((err) => {});
  };

  //  console.log( OrderDatas?.userPayToOrder)
  return (
    <div>
      <Header />
      <SideNav />

      <div class="WrapperArea">
        <div class="WrapperBox">
          <div class="TitleBox">
            <div>
              <h4>
                <Link to="/order-management">
                  {" "}
                  <img src={Back} />
                </Link>
                Store Order Details
              </h4>
            </div>
            <span class="StatusTable">
              <div
                class="form-group"
                style={{ marginTop: "13px", marginLeft: "100px" }}
              >
                <label>Service Type :</label>
                <p>{OrderDatas?.serviceType}</p>
              </div>
            </span>
            <span class="StatusTable">
              <div class="form-group">
                <label>Order Status :</label>
                {OrderDatas?.status === "Completed" ? (
                  <>
                    <p style={{ marginTop: "19px" }}>ORDER IS COMPLETED</p>
                  </>
                ) : (
                  <>
                    {OrderDatas?.status === "Received" ? (
                      <>
                        <button
                          onClick={() =>
                            changeOrderStatus(OrderDatas?._id, "Preparing")
                          }
                          className="StatusPending"
                        >
                          Accept
                        </button>
                      </>
                    ) : (
                      <>
                        {/* <select
                      onClick={() => changeOrderStatus(OrderDatas?._id, status)}
                      class="form-control"
                      name="status"
                      value={status}
                      onChange={handleChange}
                    >
                    
                      <option value="Preparing"> Preparing</option>
                      <option value="Completed">Completed</option>
                    </select> */}
                        <button
                          onClick={() =>
                            changeOrderStatus(OrderDatas?._id, "Completed")
                          }
                          className="StatusPending"
                        >
                          Complete
                        </button>
                      </>
                    )}
                  </>
                )}
              </div>
            </span>
          </div>
          <div className="Small-Wrapper">
            <div className="StoreOrder">
              <div class="DetailsInner">
                <div class="RightDetails">
                  <article>
                    <h4>Order Id: {OrderDatas?.orderNumber}</h4>
                  </article>
                </div>

                <div class="LeftDetails">
                  <aside>
                    <p>Payment Status :</p>
                    {OrderDatas?.userPayToOrder ? (
                      <h5 style={{ color: "green" }} class="Blue">
                        Payment Done
                      </h5>
                    ) : (
                      <h5 style={{ color: "red" }} class="Blue red">
                        Payment Pending
                      </h5>
                    )}
                  </aside>
                  <aside>
                    <p>Payment Method :</p>
                    <h5 class="Blue">{OrderDatas?.paymentMethod}</h5>
                  </aside>
                  <aside>
                    <p>Ordered On</p>
                    <h5 class="Blue">{OrderDatas?.createdAt?.split("T")[0]}</h5>
                  </aside>
                </div>
              </div>
              <div class="CategoryDetails">
                <ul>
                  <li>
                    <span>Customer Name: {OrderDatas?.userId?.fullName}</span>
                  </li>
                  <li>
                    <span>
                      Contact No : {OrderDatas?.userId?.countryCode}{" "}
                      {OrderDatas?.userId?.phoneNumber}
                    </span>
                  </li>
                  <li>
                    <span>Email: {OrderDatas?.userId?.email}</span>
                  </li>
                  <li>
                    <span>Dine In For : {OrderDatas?.dineInFor || 0}</span>
                  </li>

                  {OrderDatas?.specialRequest && (
                    <li>
                      <span style={{ color: "red" }}>
                        Special Request: {OrderDatas?.specialRequest || ""}
                      </span>
                    </li>
                  )}
                </ul>
              </div>
              <div class="PriceContent">
                <div class="row">
                  <div class="col-sm-2">
                    <div class="TraderBox TraderBox1">
                      <h4>SAR {OrderDatas?.paymentAmount}</h4>
                      <p>Billing Price</p>
                    </div>
                  </div>
                  <div class="col-sm-2">
                    <div class="TraderBox TraderBox2">
                      <h4>SAR {OrderDatas?.userPayToOrder}</h4>
                      <p>Discounted Price</p>
                    </div>
                  </div>
                  <div class="col-sm-2">
                    <div class="TraderBox TraderBox2">
                      {}
                      <h4>SAR {OrderDatas?.discountedAmount}</h4>
                      <p>Discounted Price</p>
                    </div>
                  </div>
                  <div class="col-sm-2">
                    <div class="TraderBox TraderBox3">
                      <h4>SAR {OrderDatas?.discountedPercent}%</h4>
                      <p>Discount</p>
                    </div>
                  </div>

                  <div class="col-sm-2">
                    <div class="TraderBox TraderBox4">
                      <h4>SAR {OrderDatas?.discountedAmount}</h4>
                      <p>Total Savings</p>
                    </div>
                  </div>
                  <div class="col-sm-2">
                    <div class="TraderBox TraderBox5">
                      <h4>{OrderDatas?.adminComission}</h4>
                      <p>Admin's Commission</p>
                    </div>
                  </div>
                  <div class="col-sm-2">
                    <div class="TraderBox TraderBox6">
                      <h4>SAR {OrderDatas?.paymentAmount}</h4>
                      <p>Total Earning</p>
                    </div>
                  </div>
                </div>
              </div>
              <p className="RightPara">
                <Link to="" className="Button AddButton">
                  View Bill
                </Link>
              </p>
              <div className="ProductList">
                <ul>
                  {OrderDatas &&
                  OrderDatas?.orderData &&
                  OrderDatas?.orderData?.length > 0 ? (
                    <>
                      {OrderDatas?.orderData?.map((ele, index) => (
                        // console.log("ele", ele?.productId?.image)
                        <li>
                          <figure>
                            <img src={ele?.productId?.image} />
                          </figure>
                          <div className="ListContant">
                            <h5>
                              {ele?.name} <span>{/* <img src={Veg} /> */}</span>
                            </h5>
                            <h6>
                              {ele?.size} ({ele?.productId?.description})
                            </h6>
                            <p>{/* {ele?.desc} */}</p>
                            <ul className="ExtaAdd">
                              {ele && ele?.addOns ? (
                                <>
                                  {ele?.addOns?.map((item) => {
                                    return (
                                      <>
                                        <li>
                                          {" "}
                                          {item?.name}{" "}
                                          <span>(SAR {item?.charges})</span>
                                        </li>
                                      </>
                                    );
                                  })}
                                </>
                              ) : (
                                <></>
                              )}
                            </ul>
                            <ul className="ExtaAdd">
                              {ele && ele?.choices ? (
                                <>
                                  {ele?.choices?.map((item) => {
                                    return (
                                      <>
                                        <li>
                                          {" "}
                                          {item?.name}{" "}
                                          <span>(SAR {item?.charges})</span>
                                        </li>
                                      </>
                                    );
                                  })}
                                </>
                              ) : (
                                <></>
                              )}
                            </ul>
                            <article>
                              <aside>
                                <span className="RedMain">{`SAR ${ele?.price}`}</span>
                              </aside>
                              <aside>
                                {/* {ele?.variantId?.price} */}
                                <span className="GreenMain">
                                  {`${ele?.quantity} Qty`}{" "}
                                </span>
                              </aside>
                              <aside>
                                {/* <span className="BlueMain">{`SAR ${ele?.varientId?.discountedPrice}`}</span> */}
                              </aside>
                            </article>
                          </div>
                        </li>
                      ))}
                    </>
                  ) : (
                    <>
                      <h2 className="NoDataFound">NO DATA FOUND</h2>
                    </>
                  )}
                </ul>
              </div>
              <div class="PaymentBox">
                <h4>Payment Details</h4>
                <table>
                  <tbody>
                    <tr>
                      <td>Item Total </td>
                      <td> {OrderDatas?.orderData?.length} Qty</td>
                      <td>SAR {OrderDatas?.total}</td>
                    </tr>
                    <tr>
                      <td>Applied Discount</td>
                      <td> {OrderDatas?.discountedPercent}% </td>
                      <td>
                        <span className="Red">
                          {" "}
                          - SAR {OrderDatas?.discountedAmount}{" "}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>Applicable Taxes</td>
                      <td>15% </td>
                      <td>SAR {OrderDatas?.tax}</td>
                    </tr>
                    <tr>
                      <td>Total Paid Amount</td>
                      <td></td>
                      <td>
                        <span className="Green">
                          {" "}
                          SAR {OrderDatas?.paymentAmount}{" "}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* <div class="PaymentBox">
                <h4>Payment Details</h4>
                <table>
                  <tbody>
                    <tr>
                      <td>Item Total </td>
                      <td> { OrderDatas?.orderData?.length} item </td>
                      <td>SAR {OrderDatas?.total}</td>
                    </tr>
                    <tr>
                      <td>Applied Discount</td>
                      <td> {OrderDatas?.discountedPercent}% </td>
                      <td>
                        <span className="Red"> - {OrderDatas?.discountedAmount} </span>
                      </td>
                    </tr>
                    <tr>
                      <td>Applicable Taxes</td>
                      <td> </td>
                      <td>{OrderDatas?.tax}</td>
                    </tr>
                    <tr>
                      <td>Total Paid Amount</td>
                      <td></td>
                      <td>
                        <span className="Green">  {OrderDatas?.paymentAmount} </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default StoreOrderDetails;

// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import "../App.css";
// import Header from "./header";
// import SideNav from "./sidenav";
// import Back from "../assets/images/arrow2.png";
// import Product1 from "../assets/images/product-1.jpg";
// import Product2 from "../assets/images/product-2.jpg";
// import Product3 from "../assets/images/product-3.jpg";
// import Product4 from "../assets/images/product-4.jpg";
// import Veg from "../assets/images/veg.png";
// import NonVeg from "../assets/images/non-veg.png";

// const OrderDetails = () => {

//     return (
//         <div>
//             <Header />
//             <SideNav />

//             <div class="WrapperArea">
//                 <div class="WrapperBox">
//                     <div class="TitleBox">
//                         <div>
//                             <h4><Link to="/order-management" > <img src={Back} /></Link>  Order Details</h4>
//                         </div>
//                         <span class="StatusTable">
//                             <div class="form-group">
//                                 <label>Order Status :</label>
//                                 <select class="form-control">
//                                     <option> Preparing</option>
//                                     <option>Received</option>
//                                     <option>Completed</option>
//                                 </select>
//                             </div>
//                         </span>
//                     </div>
//                     <div className="Small-Wrapper">
//                         <div className="StoreOrder">
//                             <div class="DetailsInner">
//                                 <div class="RightDetails">
//                                     <article>
//                                         <h4>Order Id: Order3535</h4>
//                                     </article>
//                                 </div>
//                                 <div class="LeftDetails">
//                                     <aside>
//                                         <p>Ordered On</p>
//                                         <h5 class="Blue">22 June 2022 at 3:00 PM</h5>
//                                     </aside>
//                                 </div>
//                             </div>
//                             <div class="CategoryDetails">
//                                 <ul>
//                                     <li><span>Customer Name: Simmi Sharma</span></li>
//                                     <li><span>Mobile no.: +91- 987554644</span></li>
//                                     <li><span>Email: simmi.sharma@gmail.com</span></li>
//                                 </ul>
//                             </div>
//                             <div class="PriceContent">
//                                 <div class="row">
//                                     <div class="col-sm-3">
//                                         <div class="TraderBox TraderBox1">
//                                             <h4>$ 44</h4>
//                                             <p>Billing Price</p>
//                                         </div>
//                                     </div>
//                                     <div class="col-sm-3">
//                                         <div class="TraderBox TraderBox2">
//                                             <h4>$ 24</h4>
//                                             <p>Discounted Price</p>
//                                         </div>
//                                     </div>
//                                     <div class="col-sm-3">
//                                         <div class="TraderBox TraderBox3">
//                                             <h4>40%</h4>
//                                             <p>Discount %</p>
//                                         </div>
//                                     </div>

//                                     <div class="col-sm-3">
//                                         <div class="TraderBox TraderBox4">
//                                             <h4>$ 18</h4>
//                                             <p>Total Savings</p>
//                                         </div>
//                                     </div>
//                                     <div class="col-sm-3">
//                                         <div class="TraderBox TraderBox5">
//                                             <h4>$ 120</h4>
//                                             <p>Admin's Commission</p>
//                                         </div>
//                                     </div>
//                                     <div class="col-sm-3">
//                                         <div class="TraderBox TraderBox6">
//                                             <h4>$ 12</h4>
//                                             <p>Total Earning</p>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                             <p className="RightPara"><Link to="" className="Button AddButton">View Bill</Link></p>
//                             <div className="ProductList">
//                                 <ul>
//                                     <li>
//                                         <figure>
//                                             <img src={Product1} />
//                                         </figure>
//                                         <div className="ListContant">
//                                             <h5>Mexican Pizza <span><img src={Veg} /></span></h5>
//                                             <h6>Medium (Serves 2, 2.77 cm)      Extra Cheese</h6>
//                                             <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum</p>
//                                             <article>
//                                                 <aside>
//                                                     <span className="RedMain">$ 20</span>
//                                                 </aside>
//                                                 <aside>
//                                                     <span className="GreenMain">2 Qty  </span>
//                                                 </aside>
//                                                 <aside>
//                                                     <span className="BlueMain"> $40</span>
//                                                 </aside>
//                                             </article>
//                                         </div>
//                                     </li>
//                                     <li>
//                                         <figure>
//                                             <img src={Product2} />
//                                         </figure>
//                                         <div className="ListContant">
//                                             <h5>Mexican Pizza <span><img src={Veg} /></span></h5>
//                                             <h6>Medium (Serves 2, 2.77 cm)      Extra Cheese</h6>
//                                             <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum</p>
//                                             <article>
//                                                 <aside>
//                                                     <span className="RedMain">$ 20</span>
//                                                 </aside>
//                                                 <aside>
//                                                     <span className="GreenMain">2 Qty  </span>
//                                                 </aside>
//                                                 <aside>
//                                                     <span className="BlueMain"> $40</span>
//                                                 </aside>
//                                             </article>
//                                         </div>
//                                     </li>
//                                     <li>
//                                         <figure>
//                                             <img src={Product3} />
//                                         </figure>
//                                         <div className="ListContant">
//                                             <h5>Mexican Pizza <span><img src={NonVeg} /></span></h5>
//                                             <h6>Medium (Serves 2, 2.77 cm)      Extra Cheese</h6>
//                                             <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum</p>
//                                             <article>
//                                                 <aside>
//                                                     <span className="RedMain">$ 20</span>
//                                                 </aside>
//                                                 <aside>
//                                                     <span className="GreenMain">2 Qty  </span>
//                                                 </aside>
//                                                 <aside>
//                                                     <span className="BlueMain"> $40</span>
//                                                 </aside>
//                                             </article>
//                                         </div>
//                                     </li>
//                                 </ul>
//                             </div>
//                             <div class="PaymentBox">
//                                 <h4>Payment Details</h4>
//                                 <table>
//                                     <tbody>
//                                         <tr>
//                                             <td>Item Total </td>
//                                             <td>$10 * 2 </td>
//                                             <td>$ 20</td>

//                                         </tr>
//                                         <tr>
//                                             <td>Applied Discount</td>
//                                             <td>  25%   </td>
//                                             <td><span className="Red">   -$  10</span></td>

//                                         </tr>
//                                         <tr>
//                                             <td >Applicable Taxes</td>
//                                             <td> 5%  </td>
//                                             <td>$  2</td>
//                                         </tr>
//                                         <tr>
//                                             <td>Total Paid Amount</td>
//                                             <td></td>
//                                             <td><span className="Green"> $  12</span></td>

//                                         </tr>
//                                     </tbody>
//                                 </table>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// }
// export default OrderDetails
